import { Mail } from "lucide-react";

const ContactSection = () => {
  return (
    <section
      id="contact"
      data-testid="contact-section"
      className="py-20 lg:py-28 bg-[#F8FAFC]">

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Section Header */}
        <div className="text-center mb-16">
          <h2
            data-testid="contact-title"
            className="text-3xl sm:text-4xl lg:text-5xl font-bold tracking-tight text-[#0F172A]"
            style={{ fontFamily: "'Space Grotesk', sans-serif" }}>

            Get in Touch
          </h2>
          <p className="mt-4 text-lg text-[#0F172A]/60 max-w-2xl mx-auto">
            Have questions? We'd love to hear from you. Reach out to us through any of the channels below.
          </p>
        </div>

        {/* Centered Contact Info Panel */}
        <div className="flex items-center justify-center">
          <div
            className="relative rounded-3xl overflow-hidden p-8 lg:p-12 w-full max-w-2xl min-h-[350px] flex flex-col justify-center"
            style={{
              backgroundImage: `url("https://static.prod-images.emergentagent.com/jobs/8efe3dd2-f765-4cc0-8549-c94d2b68134a/images/8972d5a7f2bc7413beb2481df8ac5d1544b22ae6defa911cc25bc236ec979d45.png")`,
              backgroundSize: "cover",
              backgroundPosition: "center"
            }}>

            <div className="absolute inset-0 bg-[#0F172A]/90"></div>
            <div className="relative z-10 text-center">
              <h3
                className="text-2xl lg:text-3xl font-bold text-white mb-6"
                style={{ fontFamily: "'Space Grotesk', sans-serif" }}>

                Contact Information
              </h3>
              <p className="text-white/70 mb-8 leading-relaxed max-w-md mx-auto">
                Have a project in mind or need a custom CAD solution? Reach out to us and our team will get back to you within 24 hours.
              </p>

              <div className="flex justify-center">
                {/* Email */}
                <div className="flex flex-col items-center gap-3">
                  <div className="w-16 h-16 rounded-2xl bg-[#2563EB] flex items-center justify-center flex-shrink-0">
                    <Mail className="w-8 h-8 text-white" />
                  </div>
                  <div>
                    <p className="text-white/60 text-sm mb-1">Email us at</p>
                    <a
                      href="mailto:contact@codeyantra.com"
                      data-testid="contact-email-link"
                      className="text-white text-lg font-medium hover:text-[#06B6D4] transition-colors">

                      contact@codeyantra.com
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>);

};

export default ContactSection;